export default __webpack_public_path__ + "static/media/gallery-5.e30fd816.png";